import { render } from "./ChildInfoCard.vue?vue&type=template&id=3e244d15&scoped=true"
import script from "./ChildInfoCard.vue?vue&type=script&lang=js"
export * from "./ChildInfoCard.vue?vue&type=script&lang=js"

import "./ChildInfoCard.vue?vue&type=style&index=0&id=3e244d15&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e244d15"]])

export default __exports__